import React, { useEffect, useState } from 'react';
import { PageSectionType } from '../types';
import { filterPromosForMemberships } from '../helpers/membershipHelpers';
import { defaultUser, UserType } from '../../components/Layout';

/*
  This hook takes in a PageSectionType array and returns:
    displayedSections: A filtered array of PageSectionType, removing any sections where the slug includes ActiveMembershipStatuses
    setUser: A React SetStateAction that is used to filter out PageSections based on the user membershipState
*/
const useDisplayedSectionFilterForMembers = (sections: PageSectionType[]): [PageSectionType[], React.Dispatch<React.SetStateAction<UserType>>] => {
  const [user, setUser] = useState<UserType>(defaultUser);
  const [displayedSections, setDisplayedSections] = useState<PageSectionType[]>(sections);
  useEffect(() => {
    if (user?.fetched) {
      setDisplayedSections(
        sections.filter((section: PageSectionType) =>
          section.slug ?
            filterPromosForMemberships(true, section.slug, user.membershipState) : true)
      )
    }
  }, [user]);
  return [displayedSections, setUser]
}

export default useDisplayedSectionFilterForMembers;
